import React, { useContext, useEffect, useState } from "react";
import { SquareLoader } from "react-spinners";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "../../utils/toast";

import { api } from "../../api/api";
import AuthContext from "../../contexts/AuthCtx";
import { loginFromResponse } from "../../utils/authRedirect";
import { captureEvent, identifyUser } from "../../analytics";

function GoogleCallback() {
  const [isLoading, setIsLoading] = useState(true);
  const AuthCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");
    const isNewAccount = searchParams.get("newAccount") === "1";

    if (error) {
      toast.error("Échec de la connexion Google. Veuillez réessayer.");
      navigate("/login");
      return;
    }

    if (!token) {
      toast.error("Jeton d'authentification manquant.");
      navigate("/login");
      return;
    }

    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    api
      .get("auth/getUser")
      .then((data) => {
        const user = data.data.user;
        identifyUser({
          id: user._id,
          email: user.email,
          userStatus: user.userStatus,
          userRole: user.userRole,
        });
        if (isNewAccount) {
          captureEvent("account_created", {
            method: "google",
            email: user.email,
          });
        }
        loginFromResponse(AuthCtx, { token, user }, navigate);
      })
      .catch(() => {
        toast.error("Impossible de finaliser la connexion Google.");
        navigate("/login");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [AuthCtx, navigate, searchParams]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <SquareLoader size={80} color="#823779" loading={isLoading} />
    </div>
  );
}

export default GoogleCallback;
